import { Component, Input } from '@angular/core';
import { FileType } from '@lsq-frontend/remote-services/enterprise/common';
import {
    GetCheckImageUrlService,
    GetImageUrlRequest,
    ListCheckImagesRequest,
    ListCheckImagesService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { BaseImagePreviewComponent } from './base-image-preview.component';

@Component({
    selector: 'check-preview',
    template: `
        <lsq-image-preview
            #imagePreviewElement
            [imageType]="'check'"
            [imageUrl]="imageUrl"
            [filename]="filename"
            [downloadUrl]="downloadUrl"
            [totalPages]="totalPages"
            [failed]="failed"
            [page]="currentPage"
            (pageChange)="handlePageChange($event)"
            (fetchImage)="getImageUrl()"
        >
        </lsq-image-preview>
    `
})
export class CheckPreviewComponent extends BaseImagePreviewComponent {
    @Input() public checkKey: string;
    public downloadUrl: string;
    public failed = false;

    constructor(
        private _getCheckImageUrlService: GetCheckImageUrlService,
        private _listCheckImagesService: ListCheckImagesService
    ) {
        super();
    }

    private async _fetchImageIds(): Promise<void> {
        const listCheckImagesRequest = new ListCheckImagesRequest({
            checkKey: parseInt(this.checkKey.substring(this.checkKey.indexOf('-') + 1))
        });

        const listCheckImagesResponse = await this._listCheckImagesService.executeOnce(
            listCheckImagesRequest
        );

        this.imageIds = listCheckImagesResponse.rows.map((row) => row.imageKey);
        this.imagePageArray = listCheckImagesResponse.rows.map((row) => row.page);
        this.activeImageId = this.imageIds[0];
        this.totalPages = listCheckImagesResponse.rows.length;
    }

    public async getImageUrl(): Promise<void> {
        this.failed = false;

        if (
            !this.imagePreviewElement ||
            !this.imagePreviewElement.maxSize ||
            !this.imagePreviewElement.zoomLevel
        ) {
            return;
        }

        if (!this.imageIds && !this.activeImageId) {
            try {
                await this._fetchImageIds();
            } catch (_error) {
                this.failed = true;
                throw _error;
            }
        }

        // Get the check image.
        const getCheckImageUrlRequest = new GetImageUrlRequest({
            imageKey: this.imageId,
            format: FileType.Jpg,
            cropFit: true
        });

        if (typeof this.currentPage !== 'undefined') {
            if (this._isMultiImage) {
                getCheckImageUrlRequest.imageKey = this.imageIds[this.currentPage - 1];
                this.activeImageId = getCheckImageUrlRequest.imageKey;
            }

            getCheckImageUrlRequest.page =
                this.imagePageArray && this.imagePageArray[this.currentPage - 1]
                    ? this.imagePageArray[this.currentPage - 1]
                    : this.currentPage;
        }

        const getCheckDownloadUrlRequest = new GetImageUrlRequest({
            ...getCheckImageUrlRequest,
            format: FileType.Pdf,
            page: null
        });

        const maxWidthAndHeight = Math.floor(
            this.imagePreviewElement.maxSize * this.imagePreviewElement.zoomLevel
        );
        getCheckImageUrlRequest.zoom = this.imagePreviewElement.zoomLevel * 100;
        getCheckImageUrlRequest.width = maxWidthAndHeight;
        getCheckImageUrlRequest.height = maxWidthAndHeight;

        try {
            const [getCheckImageUrlResponse, getCheckDownloadUrlResponse] = await Promise.all([
                this._getCheckImageUrlService.executeOnce(getCheckImageUrlRequest),
                this._getCheckImageUrlService.executeOnce(getCheckDownloadUrlRequest)
            ]);
            this.imageUrl = getCheckImageUrlResponse.url;
            this.downloadUrl = getCheckDownloadUrlResponse.url;
        } catch (_error) {
            this.failed = true;
            throw _error;
        }
    }
}
